import { mergeClasses } from '@blank/utilities'
import { Image } from 'modules/common/components/Image/Image'
import { Amount } from 'modules/common/components/_ui/Amount/Amount'

interface Props {
  rewardAmount: number
  recipient: 'referee' | 'referrer'
  className?: string
}

const SPONSORSHIP_REWARD_IMAGE_SRC: Record<Props['recipient'], string> = {
  referee: '/assets/img/sponsorship-referee-reward.png',
  referrer: '/assets/img/sponsorship-referrer-reward.png',
}

export const SponsorshipReward = ({
  rewardAmount,
  recipient,
  className,
}: Props) => {
  return (
    <div
      className={mergeClasses('space-y flex flex-col items-center', className)}
    >
      <Amount
        size="2xl"
        amount={rewardAmount}
        displayDecimal="ignoreZero"
        withAsterisk
      />
      <Image
        alt="sponsorship-reward-img"
        height="52"
        width="144"
        src={SPONSORSHIP_REWARD_IMAGE_SRC[recipient]}
      />
    </div>
  )
}
